import {Injectable} from '@angular/core';
import {map, Observable} from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import {ImssEmployerRegistryResponse} from '@models/imss-employer-registry.interface';
import {buildPath} from '@utils/util-builder';
import {ApiResponse} from '@models/api.response';
import {Page, paginatorToHttpParams} from '@utils/paginator-util';
import {ImssRiskClass} from '@models/imss-risk-class.interface';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';


@Injectable({
    providedIn: 'root'
})
export class ImssEmployerRegistryService {
    private readonly baseUrl: string = 'data-core/imss-employer-registries';

    constructor(private readonly _http: HttpClient) {
    }

    getImssEmployerRegistries(): Observable<ImssEmployerRegistryResponse[]> {
        const url: string = buildPath([this.baseUrl, 'all']);
        return this._http.get<ApiResponse<ImssEmployerRegistryResponse[]>>(url)
            .pipe(map((response: ApiResponse<ImssEmployerRegistryResponse[]>): ImssEmployerRegistryResponse[] => response.data!));
    }

    getPagedImssEmployerRegistries(paginator: MatPaginator, sortState: MatSort, companyId?: number): Observable<Page<ImssEmployerRegistryResponse[]>> {
        let params: HttpParams = paginatorToHttpParams(paginator, undefined, sortState);
        if (companyId !== undefined) {
            params = params.set('contractorId', companyId);
        }

        return this._http.get<ApiResponse<Page<ImssEmployerRegistryResponse[]>>>(buildPath([this.baseUrl]), {params})
            .pipe(map((response: ApiResponse<Page<ImssEmployerRegistryResponse[]>>): Page<ImssEmployerRegistryResponse[]> => response.data!));
    }

    createImssEmployerRegistry(data: FormData): Observable<ImssEmployerRegistryResponse> {
        const url: string = buildPath([this.baseUrl]);
        return this._http.post<ApiResponse<ImssEmployerRegistryResponse>>(url, data)
            .pipe(map((response: ApiResponse<ImssEmployerRegistryResponse>): ImssEmployerRegistryResponse => response.data!));
    }

    updateImssEmployerRegistry(id: number, data: FormData): Observable<ImssEmployerRegistryResponse> {
        const url: string = buildPath([this.baseUrl, id.toString()]);
        return this._http.put<ApiResponse<ImssEmployerRegistryResponse>>(url, data)
            .pipe(map((response: ApiResponse<ImssEmployerRegistryResponse>): ImssEmployerRegistryResponse => response.data!));
    }

    deleteImssEmployerRegistry(id: number): Observable<void> {
        return this._http.delete<void>(buildPath([this.baseUrl, id.toString()]));
    }

    getRiskClasses(): Observable<ImssRiskClass[]> {
        return this._http.get<ApiResponse<ImssRiskClass[]>>(buildPath([this.baseUrl, 'risk-classes']))
            .pipe(map((response: ApiResponse<ImssRiskClass[]>): ImssRiskClass[] => response.data!));
    }

    downloadAltaPatronal(id: number): Observable<Blob> {
        return this._http.get(buildPath([this.baseUrl, id.toString(), 'alta-patronal', 'download']), {responseType: 'blob'});
    }

}
